import { RTK_MIDDLEWARE_CONFIG } from '@disco/constants/environment'
import { rootReducer } from '@disco/state-management/reducers/root'
import { configureStore } from '@reduxjs/toolkit'
import mixpanelBrowser from 'mixpanel-browser'
import MixpanelMiddleware from 'redux-mixpanel-middleware'
import autosave from '../middlewares/autosave'
import errorReporter from '../middlewares/error-reporter'
import mixpanelExtender from '../middlewares/mixpanel-extender'
import tokenExpirer from '../middlewares/token-expire'
import searchPreferencesSync from '../middlewares/search-preferences-sync'
import { userBusinessesApi } from '@disco/state-management/ducks/businesses'
import { api } from '@disco/state-management/api/index'
export default function makeStore() {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => {
      const mixpanel = new MixpanelMiddleware(mixpanelBrowser)
      const mainAppMiddlewares = [
        autosave,
        mixpanelExtender,
        mixpanel,
        tokenExpirer,
        errorReporter,
        searchPreferencesSync,
        userBusinessesApi.middleware,
        api.middleware,
      ]
      return getDefaultMiddleware(RTK_MIDDLEWARE_CONFIG).concat(
        ...mainAppMiddlewares,
      )
    },
    devTools: __DEBUG__,
  })
}

// Get the type of our store variable
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = AppStore['dispatch']
